__turbopack_context__.v({
  "cursor": "AboutName-module-scss-module__j0mmBq__cursor",
  "host": "AboutName-module-scss-module__j0mmBq__host",
  "line": "AboutName-module-scss-module__j0mmBq__line",
  "scaler": "AboutName-module-scss-module__j0mmBq__scaler",
});
